import { memo } from 'react'
import { FormattedMessage } from 'react-intl'
import { View } from 'react-native'
import styled from 'styled-components'
import { H1 } from '@flix/common/elements/typography'
import { media, useMediaIs } from '@flix/common/style/media'

const Container = styled(View)`
  flex-direction: row;
  width: 100%;
  margin-bottom: ${(props) => props.theme.spacing.md}px;
  padding: ${(props) => props.theme.spacing.sm}px ${(props) => props.theme.spacing.sm}px;

  ${media.sm`
    padding-left: ${(props) => props.theme.spacing.xs}px;
    border-bottom-width: 1px;
    border-bottom-color: ${(props) => props.theme.colors.gray};
  `}
`

const EmptyContainer = styled(View)`
  margin-bottom: ${(props) => props.theme.spacing.md}px;
`

const HeaderText = styled(H1)`
  margin: 0;
`

export const PageHeading = memo(({ message, style, children }) => {
  const isLg = useMediaIs('lg')
  return isLg ? (
    <EmptyContainer />
  ) : (
    <Container style={style}>
      <HeaderText>{message ? <FormattedMessage {...message} /> : children}</HeaderText>
    </Container>
  )
})
